/* @flow */

import api from '../api'

export const getBrandData = (id) =>
  api.get(`/brand-data/${id}`)
